export default {
  ID_OOBC_GENERAL_CONFIRM: "확인",
  ID_OOBC_GENERAL_CANCEL: "취소",
  ID_OOBC_GENERAL_DELETE: "삭제",
  ID_OOBC_GENERAL_CLEAR: "지우기",
  ID_OOBC_GENERAL_REPLACE: "교체",
  ID_OOBC_GENERAL_CLOSE: "닫기",

  ID_OOBC_BLOCK_STRING_DEFAULT: "문자",
  ID_OOBC_BLOCK_NUMBER_DEFAULT: "숫자",

  ID_OOBC_BLOCK_ACTION_SET: "=",
  ID_OOBC_BLOCK_ACTION_MOVE: "Move",
  ID_OOBC_BLOCK_ACTION_MOVETO: "MoveTo",
  ID_OOBC_BLOCK_ACTION_GO: "Go",
  ID_OOBC_BLOCK_ACTION_GOTO: "GoTo",
  ID_OOBC_BLOCK_ACTION_ROTATE: "Rotate",
  ID_OOBC_BLOCK_ACTION_TURN: "Turn",
  ID_OOBC_BLOCK_ACTION_TURNTO: "TurnTo",
  ID_OOBC_BLOCK_ACTION_ADDSIZE: "AddSize",
  ID_OOBC_BLOCK_ACTION_PLAYANIMATION: "Animate",
  ID_OOBC_BLOCK_ACTION_STOPANIMATION: "StopAnimate",
  ID_OOBC_BLOCK_ACTION_SHOW: "Show",
  ID_OOBC_BLOCK_ACTION_HIDE: "Hide",
  ID_OOBC_BLOCK_ACTION_WAIT: "Wait",
  ID_OOBC_BLOCK_ACTION_SETCOLLISION: "Collide",
  ID_OOBC_BLOCK_ACTION_ONTOUCH: "Touch",
  ID_OOBC_BLOCK_ACTION_ONTOUCHUP: "TouchUp",
  ID_OOBC_BLOCK_ACTION_ONOUT: "Out",
  ID_OOBC_BLOCK_ACTION_ONCOLLIDE: "Collide",
  ID_OOBC_BLOCK_ACTION_ONCOLLIDEONCE: "CollideOnce",
  ID_OOBC_BLOCK_ACTION_ONCOLLIDEEND: "CollideEnd",
  ID_OOBC_BLOCK_ACTION_ONCONTACT: "Contact",
  ID_OOBC_BLOCK_ACTION_ONOVERLAP: "Overlap",
  ID_OOBC_BLOCK_ACTION_ONOVERLAPONCE: "OverlapOnce",
  ID_OOBC_BLOCK_ACTION_ONKEY: "KeyDown",
  ID_OOBC_BLOCK_ACTION_ONKEYUP: "KeyUp",
  ID_OOBC_BLOCK_ACTION_SAY: "Say",
  ID_OOBC_BLOCK_ACTION_SHAKE: "Shake",
  ID_OOBC_BLOCK_ACTION_FLASH: "Flash",
  ID_OOBC_BLOCK_ACTION_CHANGESCENE: "Change",
  ID_OOBC_BLOCK_ACTION_ONFRAME: "Frame",
  ID_OOBC_BLOCK_ACTION_ONSWIPE: "Swipe",
  ID_OOBC_BLOCK_ACTION_VIBRATE: "Vibrate",
  ID_OOBC_BLOCK_ACTION_SPEAK: "Speak",
  ID_OOBC_BLOCK_ACTION_ONSHAKE: "Shake",
  ID_OOBC_BLOCK_ACTION_BIND: "Bind",
  ID_OOBC_BLOCK_ACTION_PLAY: "Play",
  ID_OOBC_BLOCK_ACTION_RESTART: "Restart",
  ID_OOBC_BLOCK_ACTION_RESUME: "Resume",
  ID_OOBC_BLOCK_ACTION_STOP: "Stop",
  ID_OOBC_BLOCK_ACTION_PAUSE: "Pause",
  ID_OOBC_BLOCK_ACTION_KILL: "Kill",
  ID_OOBC_BLOCK_ACTION_SPAWN: "Spawn",
  ID_OOBC_BLOCK_ACTION_REVIVE: "Revive",
  ID_OOBC_BLOCK_ACTION_SENDSIGNAL: "Signal",
  ID_OOBC_BLOCK_ACTION_ONSIGNAL: "OnSignal",
  ID_OOBC_BLOCK_ACTION_SHOWRANKING: "ShowDESC",
  ID_OOBC_BLOCK_ACTION_SHOWRANKINGASCENDING: "ShowASC",
  ID_OOBC_BLOCK_ACTION_SAVESCORE: "SaveScore",
  ID_OOBC_BLOCK_ACTION_STARTTIMER: "Start",
  ID_OOBC_BLOCK_ACTION_PAUSETIMER: "Pause",
  ID_OOBC_BLOCK_ACTION_RESUMETIMER: "Resume",
  ID_OOBC_BLOCK_ACTION_RESETTIMER: "Reset",

  ID_OOBC_BLOCK_PROPERTY_TEXT: "text",
  ID_OOBC_BLOCK_PROPERTY_X: "x",
  ID_OOBC_BLOCK_PROPERTY_Y: "y",
  ID_OOBC_BLOCK_PROPERTY_WIDTH: "width",
  ID_OOBC_BLOCK_PROPERTY_HEIGHT: "height",
  ID_OOBC_BLOCK_PROPERTY_SIZE: "scale",
  ID_OOBC_BLOCK_PROPERTY_SCALE: "scale",
  ID_OOBC_BLOCK_PROPERTY_DEGREE: "degree",
  ID_OOBC_BLOCK_PROPERTY_MASS: "mass",
  ID_OOBC_BLOCK_PROPERTY_MOVESPEED: "moveSpeed",
  ID_OOBC_BLOCK_PROPERTY_DRAGGABLE: "draggable",
  ID_OOBC_BLOCK_PROPERTY_MOVABLE: "movable",
  ID_OOBC_BLOCK_PROPERTY_FLIPX: "flipX",
  ID_OOBC_BLOCK_PROPERTY_FLIPY: "flipY",
  ID_OOBC_BLOCK_PROPERTY_VELOCITYX: "velocityX",
  ID_OOBC_BLOCK_PROPERTY_VELOCITYY: "velocityY",
  ID_OOBC_BLOCK_PROPERTY_VELOCITYZ: "velocityZ",
  ID_OOBC_BLOCK_PROPERTY_GRAVITYX: "gravityX",
  ID_OOBC_BLOCK_PROPERTY_GRAVITYY: "gravityY",
  ID_OOBC_BLOCK_PROPERTY_BOUNCEX: "bounceX",
  ID_OOBC_BLOCK_PROPERTY_BOUNCEY: "bounceY",
  ID_OOBC_BLOCK_PROPERTY_ACCELERATIONX: "accelerationX",
  ID_OOBC_BLOCK_PROPERTY_ACCELERATIONY: "accelerationY",

  ID_OOBC_BLOCK_CONSTANT_RANDOM: "random",
  ID_OOBC_BLOCK_CONSTANT_TOUCH: "touch",
  ID_OOBC_BLOCK_CONSTANT_TIME: "time",

  ID_OOBC_BLOCK_CATEGORY_GAMEOBJECT: "Sprite",
  ID_OOBC_BLOCK_CATEGORY_PROPERTY: "Property",
  ID_OOBC_BLOCK_CATEGORY_ACTION: "Action",
  ID_OOBC_BLOCK_CATEGORY_GLOBALACTION: "Action",
  ID_OOBC_BLOCK_CATEGORY_FUNCTION: "Function",
  ID_OOBC_BLOCK_CATEGORY_CALLBACK: "Callback",
  ID_OOBC_BLOCK_CATEGORY_VARIABLE: "Variable",
  ID_OOBC_BLOCK_CATEGORY_CONSTANT: "Constant",
  ID_OOBC_BLOCK_CATEGORY_OPERATOR: "Operator",
  ID_OOBC_BLOCK_CATEGORY_UTIL: "Util",
  ID_OOBC_BLOCK_CATEGORY_CLOSE: "닫기",

  ID_OOBC_CONTEXTMENU_DELETE: "삭제",
  ID_OOBC_CONTEXTMENU_COPY: "복사",
  ID_OOBC_CONTEXTMENU_PASTE: "붙여넣기",
  ID_OOBC_CONTEXTMENU_ADD: "추가",
  ID_OOBC_CONTEXTMENU_DISABLE: "비활성화",
  ID_OOBC_CONTEXTMENU_ENABLE: "활성화",
  ID_OOBC_CONTEXTMENU_COMMENT: "코멘트",
  ID_OOBC_CONTEXTMENU_DELETECOMMENT: "코멘트 삭제",

  ID_OOBC_ALERT_ADDVAR_TITLE: "변수 추가하기",
  ID_OOBC_ALERT_ADDVAR_MESSAGE: "*영문, 숫자만 입력 가능해요\n*첫 글자는 반드시 영문이어야 해요",
  ID_OOBC_ALERT_ADDVAR_PLACEHOLDER: "변수 이름 입력",
  ID_OOBC_ALERT_ADDVAR_INVALIDNAME_MESSAGE: "변수 이름 규칙을 확인해주세요",
  ID_OOBC_ALERT_ADDVAR_EXISTNAME_MESSAGE: "다른 변수와 이름이 같으면 안되요",
  ID_OOBC_ALERT_DISABLED_BLOCK_TITLE: "사용할 수 없는 블록",
  ID_OOBC_ALERT_DISABLED_BLOCK_MESSAGE: "여기에는 그 블록을 사용할 수 없어요",
  ID_OOBC_ALERT_DISABLED_ANIMATEBLOCK_MESSAGE: "애니메이션이 없는 스프라이트는\n애니메이트 블록을 사용할 수 없어요",
  ID_OOBC_ALERT_DELETELINE_TITLE: "라인 삭제하기",
  ID_OOBC_ALERT_DELETELINE_MESSAGE: "라인을 삭제하면 되돌릴 수 없어요.\n정말 삭제하시겠어요?",
  ID_OOBC_ALERT_REPLACE_BLOCK_TITLE: "블록 교체하기",
  ID_OOBC_ALERT_REPLACE_BLOCK_MESSAGE: "해당 블록으로 교체하면\n뒤에 오는 블록들이 지워져요.\n그래도 교체할까요?",

  ID_OOBC_CONSTANTEDITOR_KEY_MESSAGE: "키를 입력해주세요.",
};
